import React, { useEffect, useState, lazy, Suspense } from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import LogoSplash from "./LogoSplash";
import "./i18n";
import { useTranslation } from "react-i18next";

const Home = lazy(() => import("./Home/Home"));
const AgencySalesComponent = lazy(() => import("./OurBusiness/AgencySalesComponent"));
const TurnkeyEquippingAgency = lazy(() => import("./OurBusiness/TurnkeyEquippingAgency"));
const EquipmentsList = lazy(() => import("./Equipments/EquipmentsList"));
const ProjectShowcase = lazy(() => import("./Projects/ProjectShowcase"));
const CompleteDesignEngineeringPage = lazy(() => import("./Solutions/CompleteDesignEngineeringPage"));
const SpecializedSolutionsDigitalOR = lazy(() => import("./Solutions/SpecializedSolutionsDigitalOR"));
const MRIShielding3D = lazy(() => import("./Solutions/MRIShielding3D"));
const ICUPendants = lazy(() => import("./Solutions/ICUPendants"));
const DentalShowcase = lazy(() => import("./Solutions/DentalShowcase"));


// Preload map
export const preloadMap = {
  "/": () => import("./Home/Home"),
  "/agency-sales": () => import("./OurBusiness/AgencySalesComponent"),
  "/turnkey": () => import("./OurBusiness/TurnkeyEquippingAgency"),
  "/EquipmentsList": () => import("./Equipments/EquipmentsList"),
  "/ProjectShowcase": () => import("./Projects/ProjectShowcase"),
  "/CompleteDesignEngineeringPage": () => import("./Solutions/CompleteDesignEngineeringPage"),
  "/SpecializedSolutionsDigitalOR": () => import("./Solutions/SpecializedSolutionsDigitalOR"),
  "/MRIShielding3D": () => import("./Solutions/MRIShielding3D"),
  "/ICUPendants": () => import("./Solutions/ICUPendants"),
  "/DentalShowcase": () => import("./Solutions/DentalShowcase"),
  
     
};

// Scroll to top on route change
const ScrollToTop = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  }, [pathname]);
  return null;
};

function App() {
  const [loading, setLoading] = useState(true);
  const location = useLocation();
  const { i18n } = useTranslation();

  // Initial splash screen loading state
  useEffect(() => {
    const timer = setTimeout(() => setLoading(false), 2000);
    return () => clearTimeout(timer);
  }, []);

  // Preload component when route changes
  useEffect(() => {
    const preloadFunc = preloadMap[location.pathname];
    if (preloadFunc) {
      preloadFunc();
    }
  }, [location.pathname]);

  if (loading) return <LogoSplash />;

  return (
    <>
      <ScrollToTop />
      <Suspense fallback={null /* Don't show LogoSplash again */}>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/agency-sales" element={<AgencySalesComponent />} />
          <Route path="/turnkey" element={<TurnkeyEquippingAgency />} />
          <Route path="/EquipmentsList" element={<EquipmentsList />} />
          <Route path="/ProjectShowcase" element={<ProjectShowcase />} />
          <Route path="/CompleteDesignEngineeringPage" element={<CompleteDesignEngineeringPage />} />
          <Route path="/SpecializedSolutionsDigitalOR" element={<SpecializedSolutionsDigitalOR />} />
          <Route path="/MRIShielding3D" element={<MRIShielding3D />} />
          <Route path="/ICUPendants" element={<ICUPendants />} />
          <Route path="/DentalShowcase" element={<DentalShowcase />} />
        
        </Routes>
      </Suspense>
    </>
  );
}

export default App;
